import React, { useEffect } from "react";
import "./Top.scss";

export default function Top() {

  function TopEvent() {
    // Scroll to top smoothly
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  useEffect(() => {
    function scrollFunction() {
      const btn = document.getElementById("topButton");
      if (!btn) return; // Prevent crash

      // Your original logic hides the button always.
      // If you want it visible on scroll, tell me and I’ll update it.
      btn.style.visibility = "hidden";
    }

    // Attach listeners safely
    window.addEventListener("scroll", scrollFunction);
    window.addEventListener("load", scrollFunction);

    // Cleanup to prevent memory leaks
    return () => {
      window.removeEventListener("scroll", scrollFunction);
      window.removeEventListener("load", scrollFunction);
    };
  }, []);

  return (
    <button onClick={TopEvent} id="topButton" title="Go to top">
      <i className="fas fa-hand-point-up" aria-hidden="true"></i>
    </button>
  );
}
